import * as React from 'react';
import Grid from '@mui/material/Grid';
import {Button, Stack, Typography} from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {Link} from 'react-router-dom';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import {styled} from '@mui/material/styles';
import {formatHour, shortDateFormat} from '../Service';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import axios from '../../axios';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MessageIcon from '@mui/icons-material/Message';
import Box from '@mui/material/Box';
import LikeButton from '../like/LikeButton';
import {useState, useEffect, useReducer} from 'react';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EventComment from './EventComment';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import {useComments} from './hooks/useComments';
import {useLikeCount} from './hooks/useLike';
import {withJoinContext} from './joinContext';
import {useJoin} from './hooks/useJoin';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import parse from 'html-react-parser';
import {useSynchronisation} from '../event/hooks/useSynchronisation';
import {removeHtml} from '.././Service';
import {formatToVcalendarDate} from '.././Service';


const Img = styled('img')({
  top: '33px',
  left: '34px',
  display: 'block',
  width: '100%',
  height: 'auto',
  borderRadius: '5px',
});

const EventExpandMore = ({theEvent, expandMore, handleToggleClick}) => {
  const {createEvent, deleteEvent} = useSynchronisation();
  const [expandComment, setExpandComment] = useState(false);
  const handleToggleComment = () => {
    setExpandComment(!expandComment);
  };
  const {join, joinStatus, leave} = useJoin({
    isJoin: false,
    memberCount: 0,
  });
  const handleClickJoin = isJoin => {
    if (isJoin) {
      join(theEvent.id);
      createEvent(
        removeHtml(theEvent.description.text),
        theEvent.title.text,
        formatToVcalendarDate(theEvent.start_date),
        formatToVcalendarDate(theEvent.end_date),
        theEvent.location.text,
        theEvent.id,
      );
    } else {
      deleteEvent(theEvent.id);
      leave(theEvent.id);
    }
  };
  const {commentCount} = useComments(theEvent.id);
  const {likeCount} = useLikeCount('event', theEvent.id);
  const {mode} = useDarkMode();

  return (
    <Stack
      direction="column"
      justifyContent="left"
      alignItems="flex-start"
      spacing={2}
      sx={{padding: '16px', width: '98%'}}>
      <Stack
        spacing={2}
        alignContent="space-between"
        flexWrap={'wrap'}
        justifyContent={'space-between'}
        direction={'row'}
        width={'100%'}
        gap={2}>
        <Stack
          direction="column"
          justifyContent="left"
          alignItems="flex-start"
          spacing={2}>
          <Typography variant="h3" color={mode.settings.textColor3}>
            {parse(theEvent.title.text)}
          </Typography>
          <Stack
            direction="row"
            justifyContent="left"
            alignItems="flex-end"
            sx={{color: '#263238'}}>
            <FavoriteBorderIcon
              aria-label={"Nombre de j'aime"}></FavoriteBorderIcon>
            <Typography variant={'subtitle3'} sx={{marginLeft: 0.5}}>
              {likeCount} J'aime{likeCount > 1 ? 's' : ''}
            </Typography>
            <MessageIcon
              aria-label={'Nombre de commentaire'}
              sx={{marginLeft: 2, marginRight: 0.5}}></MessageIcon>
            <Typography variant={'subtitle3'}>
              {commentCount} Commentaire{commentCount > 1 ? 's' : ''}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction="row"
          justifyContent="right"
          alignItems="center"
          spacing={1}>
          {joinStatus.isMember ? (
            <Button
              className="btn-gradient"
              variant="contained"
              size="large"
              startIcon={
                <LogoutIcon role="img" aria-label={'Quitter cet événement'} />
              }
              sx={{width: '100%', marginTop: 2}}
              onClick={() => handleClickJoin(false)}
              aria-label={'Quitter cet événement'}>
              Quitter cet événement
            </Button>
          ) : (
            <Button
              className="btn-gradient"
              variant="contained"
              size="large"
              startIcon={
                <LoginIcon role="img" aria-label={'Rejoindre cet événement'} />
              }
              sx={{width: '100%', marginTop: 2}}
              onClick={() => handleClickJoin(true)}
              aria-label={'Rejoindre cet événement'}>
              <Typography variant={'subtitle1'}>
                Rejoindre cet événement
              </Typography>
            </Button>
          )}
        </Stack>
      </Stack>
      <Img
        alt={theEvent.image.alternativeText}
        src={`${axios.defaults.apiBaseURL}/${theEvent.image.uri}`}
        role="img"
      />
      {
        shortDateFormat(theEvent.start_date) !== shortDateFormat(theEvent.end_date) ?
            <Stack
                direction="row"
                justifyContent="left"
                alignItems="flex-end"
                flexWrap={'wrap'}
                sx={{color: mode.settings.textColor6}}
            >
              <CalendarMonthIcon
                  sx={{marginRight: 0.5}}
                  aria-label={"Date de début de l'évenement"}></CalendarMonthIcon>
              <Typography variant={'subtitle3'}>
                {shortDateFormat(theEvent.start_date)}
              </Typography>
              <Typography variant={'subtitle3'} sx={{marginRight: 2}}>
                &nbsp;à&nbsp;
                {formatHour(theEvent.start_date)} au&nbsp;
                {
                    shortDateFormat(theEvent.end_date) + ' à ' + formatHour(theEvent.end_date)
                }
              </Typography>
              <Stack direction={'row'}>
                <LocationOnIcon
                    aria-label={"Lieu de l'évenement"}></LocationOnIcon>
                <Typography variant={'subtitle3'}>
                  {theEvent.location.text}
                </Typography>
              </Stack>
            </Stack> :
            <Stack
                direction="row"
                justifyContent="left"
                alignItems="flex-end"
                sx={{color: mode.settings.textColor6}}
                flexWrap={'wrap'}>
              <CalendarMonthIcon
                  sx={{marginRight: 0.5}}
                  aria-label={"Date de début de l'évenement"}></CalendarMonthIcon>
              <Typography variant={'subtitle3'}>
                {shortDateFormat(theEvent.start_date)}
              </Typography>
              <AccessTimeIcon
                  sx={{marginLeft: 2, marginRight: 0.5}}
                  aria-label={"Heure de l'évenement événement"}></AccessTimeIcon>
              <Typography variant={'subtitle3'} sx={{marginRight: 2}}>
                {formatHour(theEvent.start_date)} à&nbsp;
                {formatHour(theEvent.end_date)}
              </Typography>
              <Stack direction={'row'}>
                <LocationOnIcon aria-label={'Lieu'}></LocationOnIcon>
                <Typography variant={'subtitle3'}>{theEvent.location.text}</Typography>
              </Stack>
            </Stack>
      }
      <Typography
        variant={'subtitle3'}
        sx={{marginLeft: '3px !important'}}
        color={mode.settings.textColor3}
        dangerouslySetInnerHTML={{__html: theEvent.description}}></Typography>
      <Stack
        direction="row"
        justifyContent="left"
        alignItems="center"
        sx={{color: '#3E9FDD', cursor: 'pointer'}}
        onClick={handleToggleClick}
        flexWrap={'wrap'}>
        <ArrowDropUpIcon
          className="linkArrow"
          aria-label="Voir moins"
          sx={{marginLeft: -0.4}}
        />
        <Typography variant={'subtitle1'}>
          {expandMore ? 'Afficher moins' : "Lire l'article en entier"}
        </Typography>
      </Stack>
      <Box
        sx={{padding: 1, width: '98%'}}
        style={{backgroundColor: mode.settings.card3BackgroundColor}}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          sx={{color: '#DD809D', width: '100%'}}
          flexWrap={'wrap'}
          gap={2}>
          <LikeButton type={'event'} contentId={theEvent.id} />
          {expandComment ? (
            <Button
              className="buttonOhs"
              startIcon={
                <VisibilityOffIcon
                  role={'img'}
                  aria-label="Masquer les commentaires"
                />
              }
              onClick={handleToggleComment}>
              Masquer les commentaires
            </Button>
          ) : (
            <Button
              className="buttonOhs"
              startIcon={
                <RemoveRedEyeIcon
                  role={'img'}
                  aria-label="Afficher les commentaires"
                />
              }
              onClick={handleToggleComment}>
              <Typography variant={'subtitle3'}>
                Afficher les commentaires
              </Typography>
            </Button>
          )}
        </Stack>
      </Box>
      <Box sx={{width: '100%'}}>
        {expandComment ? (
          <EventComment contentId={theEvent.id}></EventComment>
        ) : (
          <div></div>
        )}
      </Box>
    </Stack>
  );
};

export default withJoinContext(EventExpandMore);
